var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_14056)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_14056",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_14056)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19_14056",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H33V23H3V3Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19_14056)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3V23H33V3H3Z",
    fill: "#002395"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3V13H33V3H3Z",
    fill: "#DE3831"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L18 13L3 23M18 13H33H18Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L18 13M18 13L3 23M18 13H33",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_19_14056",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 15,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L18 13L3 23",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_19_14056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3L18 13L3 23",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3L18 13L3 23",
    stroke: "#FFB612",
    strokeWidth: 2
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L18 13M18 13L3 23M18 13H33",
    stroke: "#007A4D",
    strokeWidth: 1.2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_14056",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_14056"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_14056",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/SouthAfrica.9169cdb02506a232169f026ecf772528.svg";
export { ForwardRef as ReactComponent };